import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import AverageMachineSellFilter from "../filters/AverageMachineSellFilter";
import fetchHook from "../../../../../hooks/fetchMSSQL-hook";
import getGradientForBarValue from "../../utils/getGradientForBarValue";
import getYearMachinesSalesSumChartConfig from '../../configs/getYearMachinesSalesSumChartConfig'
import getYearMachinesSalesAverageChartConfig from '../../configs/getYearMachinesSalesAverageChartConfig'

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
  annotationPlugin
);

export default function YearMachinesSalesChart({showMachinesStat, setShowMachinesStat}) {
  const chartRef = useRef(null);
  const chartRef2 = useRef(null);
  const { fetchMssqlApi } = fetchHook();
  const [avarageMachinesSale, setAvarageMachinesSale] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [machineFilter, setMachineFilter] = useState("");
  const [paymentType, setPaymentType] = useState(null);
  const [machineRank, setMachineRank] = useState("all");
  const [sortType, setSortType] = useState(1);
  const [showAVG, setShowAVG] = useState(false);
  const [showMedian, setShowMedian] = useState(true);


  const getAvarageMachinesSales = async () =>
    fetchMssqlApi(
      "/stat/year-machines-sales",
      {
        method: "POST",
        hideNotification: true,
        data: { PaymentType: paymentType },
      },
      (res) => {
        setAvarageMachinesSale(res);
        sortData(sortType);
      },
      (err) => console.log(err)
    );


  const setLocalStorage = (value) => {
    try {
      const values = localStorage.getItem("statFilters");
      let parsedValue = {};
      
      if (values) {
        parsedValue = JSON.parse(values);
      }
      
      const updatedValue = { ...parsedValue, showYearMachinesStat: value };
      localStorage.setItem("statFilters", JSON.stringify(updatedValue));
    } catch (e) {
      console.log("Error updating localStorage:", e);
    }
  };

    const filteredData = avarageMachinesSale

const calculateMedianOfAverages = () => {
  if (!filteredData || filteredData.length === 0) return 0;
  
  const sortedValues = [...filteredData]
    .map(machine => parseFloat((Number(machine.PrevAverageIncomeValue || 0) + Number(machine.CurrentAverageIncomeValue || 0)) / 2 || 0))
    .sort((a, b) => a - b);
  
  const midIndex = Math.floor(sortedValues.length / 2);

  if (sortedValues.length % 2 !== 0) {
    return sortedValues[midIndex];
  } else {
    return (sortedValues[midIndex - 1] + sortedValues[midIndex]) / 2;
  }
};

const calculateMedianOfSum = () => {
  if (!filteredData || filteredData.length === 0) return 0;
  
  const sortedValues = [...filteredData]
    .map(machine => parseFloat((Number(machine.PrevSummaryIncomeValue || 0) + Number(machine.CurrentSummaryIncomeValue || 0)) / 2 || 0))
    .sort((a, b) => a - b);
  
  const midIndex = Math.floor(sortedValues.length / 2);
  
  if (sortedValues.length % 2 !== 0) {
    return sortedValues[midIndex];
  } else {
    return (sortedValues[midIndex - 1] + sortedValues[midIndex]) / 2;
  }
};

const medianOfAverages = calculateMedianOfAverages();
const medianOfSum = calculateMedianOfSum();
const getAVGSUMByMachineName = ({PrevSummaryIncomeValue, CurrentSummaryIncomeValue}) => {
  return Number(PrevSummaryIncomeValue || 0) + Number(CurrentSummaryIncomeValue || 0) || 0
}
const getAVGAVGByMachineName = ({PrevAverageIncomeValue, CurrentAverageIncomeValue}) => {
  return Number(PrevAverageIncomeValue || 0) + Number(CurrentAverageIncomeValue || 0) || 0
}
  const sortBySummaryASC = (a, b) =>
    getAVGSUMByMachineName(a) > getAVGSUMByMachineName(b) ? 1 : -1;
  const sortByAvarageASC = (a, b) =>
    getAVGAVGByMachineName(a) > getAVGAVGByMachineName(b) ? 1 : -1;
  const sortByMachineNameASC = (a, b) =>
    a.MachineFullName > b.MachineFullName ? 1 : -1;
  const sortBySummaryDESC = (a, b) =>
    getAVGSUMByMachineName(a) < getAVGSUMByMachineName(b) ? 1 : -1;
  const sortByAvarageDESC = (a, b) =>
    getAVGAVGByMachineName(a) < getAVGAVGByMachineName(b) ? 1 : -1;
  const sortByMachineNameDESC = (a, b) =>
    a.MachineFullName < b.MachineFullName ? 1 : -1;

  const sortData = (caseType) => {
    switch (+caseType) {
      case 1:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortBySummaryDESC)
        );
      case 2:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortByAvarageDESC)
        );
      case 3:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortByMachineNameDESC)
        );
      case 4:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortBySummaryASC)
        );
      case 5:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortByAvarageASC)
        );
      case 6:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortByMachineNameASC)
        );
      default:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortBySummaryDESC)
        );
    }
  };

  useEffect(() => {
    sortData(sortType);
  }, [sortType]);

  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  const applyRankFilter = (data) => {
    if (!data || data.length === 0) return [];
    switch (machineRank) {
      case "best":
        return data.slice(0, 50);
      case "worst":
        return data.slice(Math.max(0, data.length - 50)); 
      case "all":
      default:
        return data; 
    }
  };
  const currentData = applyRankFilter(filteredData)


  useEffect(() => {
    setLocalStorage(showMachinesStat);
  }, [showMachinesStat]);

  useEffect(() => {
    setCurrentPage(1);
  }, [machineFilter, machineRank]); 

  useEffect(() => {
    if (showMachinesStat) {
      getAvarageMachinesSales();
    }
    if (!showMachinesStat) {
      setMachineFilter("");
    }
    setCurrentPage(1);
  }, [paymentType, showMachinesStat]);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.update();
    }
    if (chartRef2.current) {
      chartRef2.current.update();
    }
  }, [avarageMachinesSale]);


  const calculateAverageOfAverages = () => {
    if (!avarageMachinesSale || avarageMachinesSale.length === 0) return 0;

    const sum = avarageMachinesSale.reduce(
      (acc, machine) => acc + parseFloat((Number(machine.PrevAverageIncomeValue || 0) + Number(machine.CurrentAverageIncomeValue || 0)) / 2 || 0),
      0
    );
    return sum / avarageMachinesSale.length;
  };
  const calculateAverageOfSum = () => {
    if (!avarageMachinesSale || avarageMachinesSale.length === 0) return 0;

    const sum = avarageMachinesSale.reduce(
      (acc, machine) => acc + parseFloat((Number(machine.PrevSummaryIncomeValue || 0) + Number(machine.CurrentSummaryIncomeValue || 0)) / 2 || 0),
      0
    );
    return sum / avarageMachinesSale.length;
  };
  
  const averageOfAverages = calculateAverageOfAverages();
  const averageOfSum = calculateAverageOfSum();

  const truncateMachineName = (name) => {
    return name && name.length >30 ? name.substring(0, 30) + "..." : name;
  };

  const maxAvarageValue = Math.max(
    ...avarageMachinesSale.map(getAVGAVGByMachineName)
  );
  const maxSummaryValue = Math.max(
    ...avarageMachinesSale.map(getAVGSUMByMachineName)
  );
  const summaryChartRatio =
    ((maxAvarageValue || 1) / (averageOfSum || 1)).toFixed(1) || 0;
  const avarageChartRatio =
    ((maxSummaryValue || 1) / (averageOfAverages || 1)).toFixed(1) || 0;

    useEffect(() => {
      if (chartRef.current && chartRef.current.canvas) {
        try {
          const chart = chartRef.current;
  
          if (chart.data && chart.data.datasets) {
            chart.data.datasets[0].backgroundColor = currentData.map(
              (machine) => {
                const value = parseFloat(machine.CurrentAverageIncomeValue) || 0;
                return getGradientForBarValue(
                  chart,
                  value,
                  medianOfAverages,
                  avarageChartRatio,
                );
              }
            );
            
            chart.data.datasets[1].backgroundColor = currentData.map(
              (machine) => {
                const value = parseFloat(machine.PrevAverageIncomeValue) || 0;
                return getGradientForBarValue(
                  chart,
                  value,
                  medianOfAverages,
                  avarageChartRatio,
                );
              }
            );
  
            chart.update();
          }
        } catch (e) {
          console.error("Failed to apply gradients to first chart:", e);
          
        }
      }
  
      if (chartRef2.current && chartRef2.current.canvas) {
        try {
          const chart = chartRef2.current;
  
          if (chart.data && chart.data.datasets) {
            chart.data.datasets[0].backgroundColor = currentData.map(
              (machine) => {
                const value = parseFloat(machine.CurrentSummaryIncomeValue) || 0;
                return getGradientForBarValue(
                  chart,
                  value,
                  medianOfSum,
                  summaryChartRatio,
                  'rgba(1, 64, 190, 0.9)',
                  'rgba(1, 64, 190, 0.3)'
                );
              }
            );
            
            chart.data.datasets[1].backgroundColor = currentData.map(
              (machine) => {
                const value = parseFloat(machine.PrevSummaryIncomeValue) || 0;
                return getGradientForBarValue(
                  chart,
                  value,
                  medianOfSum,
                  summaryChartRatio,
                  'rgba(197, 216, 255, 0.9)',
                  'rgba(197, 216, 255, 0.3)'
                );
              }
            );
  
            chart.update();
          }
        } catch (e) {
          console.error("Failed to apply gradients to second chart:", e);
        }
      }
    }, [currentData, currentPage, averageOfAverages, averageOfSum]);

  const chartData = {
    labels:
      currentData?.map((machine) =>
        truncateMachineName(machine.MachineFullName)
      ) || [],
    datasets: [
      {
        label: "Bieżący rok",
        data:
          currentData?.map((machine) =>
            parseFloat(machine.CurrentAverageIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
      {
        label: "Poprzedni rok",
        data:
          currentData?.map((machine) =>
            parseFloat(machine.PrevAverageIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
    ],
  };

  const chartData2 = {
    labels:
      currentData?.map((machine) =>
        truncateMachineName(machine.MachineFullName)
      ) || [],
    datasets: [
      {
        label: "Bieżący rok",
        data:
          currentData?.map((machine) =>
            parseFloat(machine.CurrentSummaryIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 10, bottomRight: 10},
        borderSkipped: false,
      },
      {
        label: "Poprzedni rok",
        data:
          currentData?.map((machine) =>
            parseFloat(machine.PrevSummaryIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 10, bottomRight: 10},
        borderSkipped: false,
      },
    ],
  };

  return (
    <div
      // className={`pb-2 ${
      //   showMachinesStat && "border-top rounded"
      // }`}
    >
      <AverageMachineSellFilter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        machineFilter={machineFilter}
        setMachineFilter={setMachineFilter}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        filteredData={filteredData}
        totalCount={avarageMachinesSale ? avarageMachinesSale.length : 0}
        paymentType={paymentType}
        setPaymentType={setPaymentType}
        machines={
          avarageMachinesSale.length
            ? avarageMachinesSale.map(({ MachineFullName }) => MachineFullName)
            : []
        }
        isVisible={showMachinesStat}
        setIsVisible={setShowMachinesStat}
        setSortType={setSortType}
        sortType={sortType}
        showAVG={showAVG}
        setShowAVG={setShowAVG}
        getData={getAvarageMachinesSales}
        showMedian={showMedian}
        setShowMedian={setShowMedian}
        machineRank={machineRank}
        setMachineRank={setMachineRank}
        chartType="year"
        title="Sprzedaż roczna (automaty)"
      />
      {filteredData.length === 0 && machineFilter && (
        <div
          className="alert"
          style={{ backgroundColor: "#C5D8FF", fontWeight: "bolder" }}
        >
          Nie znaleziono automatów pasujących do filtra "{machineFilter}"
        </div>
      )}
      {showMachinesStat && (
        <div
          className="container-fluid"
          style={{ maxHeight: "80vh", overflowY: "auto" }}
        >
          <div className="row">
            <div
              style={{
                height: `${Math.max(
                  400,
                  Math.min(currentData.length, filteredData.length) * 40
                )}px`,
              }}
              className="col-lg-6 col-md-11 col-11"
            >
              <Bar
                ref={chartRef}
                data={chartData}
                options={getYearMachinesSalesAverageChartConfig(
                  showAVG,
                  setShowAVG,
                  currentData,
                  averageOfAverages,
                  itemsPerPage,
                  showMedian,
                  medianOfAverages
                )}
              />
            </div>
            <div
              style={{
                height: `${Math.max(
                  400,
                  Math.min(currentData.length, filteredData.length) * 40
                )}px`,
              }}
              className="col-lg-6 col-md-11 col-11"
            >
              <Bar
                ref={chartRef2}
                data={chartData2}
                options={getYearMachinesSalesSumChartConfig(
                  showAVG,
                  setShowAVG,
                  currentData,
                  averageOfSum,
                  itemsPerPage,
                  showMedian,
                  medianOfSum
                )}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
